import { render, staticRenderFns } from "./power-add.vue?vue&type=template&id=2f9635ca&scoped=true&"
import script from "./power-add.vue?vue&type=script&lang=js&"
export * from "./power-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9635ca",
  null
  
)

export default component.exports